import { render } from "./sectionOf.vue?vue&type=template&id=30f51af3"
import script from "./sectionOf.vue?vue&type=script&lang=js"
export * from "./sectionOf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__